/**
 * まとめて実行したうち、できなかったものの一覧（お名前と理由・docs/06 5-2 の「実行」の段）。
 *
 * 結果の帯の「次にすること」の欄に置く。できなかった理由を1件ずつ出し、黙って数だけにしない（決定22）。
 *
 * 受け持ちの範囲の外になった方・トーク（一覧を作ったあとに拠点が変わったなど）は、サーバが名前を返さない
 * （「（名簿にない方）」「（不明なトーク）」・issue #474 P-1）。この画面で選んだものなら、選んだときに
 * 一覧で見ていた名前を出す（管理者の方がすでに見ていた名前なので、新しく教えることにはならない）。
 * 名前の代わりの言葉（かっこで始まる）には「さん」を付けない。
 */
import type { ReactNode } from 'react';

export function BulkSkippedList({
  skipped,
  suffix = '',
  knownNames,
}: {
  skipped: { id: string; name: string; reason: string }[];
  /** お名前のあとに付ける言葉（人なら「さん」） */
  suffix?: string;
  /** この画面で選んだときの名前（id → 名前）。サーバが名前を返さなかったときに使う */
  knownNames?: ReadonlyMap<string, string>;
}): ReactNode {
  return (
    <>
      できなかったものと、その理由です。
      <ul className="admin-bulk-skipped">
        {skipped.map((row) => (
          <li key={row.id}>
            {labelOf(knownNames?.get(row.id) ?? row.name, suffix)}：{row.reason}
          </li>
        ))}
      </ul>
    </>
  );
}

function labelOf(name: string, suffix: string): string {
  if (name === '') return '（名前なし）';
  // 「（名簿にない方）」などの名前の代わりの言葉には「さん」を付けない
  return name.startsWith('（') ? name : `${name}${suffix}`;
}
